const fa = {
  pickerNarrow: 'برای دیدن بقیهٔ نتایج، نام یا عنوان دقیق‌تری جست‌وجو کنید.',
  pickerLimit: 'حداکثر {count} مورد می‌توانید انتخاب کنید؛ برای انتخاب مورد جدید، یکی را حذف کنید.',
  pickerResults: 'نتایج جست‌وجو',
  pickerPages: 'صفحه‌های نتایج جست‌وجو',
  pickerPage: 'صفحه {page} از {pages}',
  tagSearchHint: 'نوشتن نام برچسب کافی نیست؛ «جست\u200cوجو و انتخاب» را بزنید و نتیجهٔ موردنظر را انتخاب کنید.',
  noTagOptions: 'برچسبی پیدا نشد. نام کوتاه\u200cتری جست\u200cوجو کنید یا برای جست\u200cوجو در متن مطلب، عبارت کلیدی اضافه کنید.',
  tagSuggestions: 'نتیجهٔ دقیقی پیدا نشد. این نام\u200cهای نزدیک را بررسی کنید؛ هنوز چیزی انتخاب نشده است.',
  searchOtherArticles: 'جست\u200cوجو در مطالب دیگر',
  reviewRequired: 'بررسی موارد لازم',
  titleBodyTags: 'عنوان، متن و نام برچسب\u200cها',
  tagMatchingHint: 'برچسب\u200cها فقط برچسب\u200cهای ثبت\u200cشدهٔ مطلب را بررسی می\u200cکنند. برای جست\u200cوجوی کلمه در متن یا نام برچسب\u200cها، از عبارت\u200cهای کلیدی در تنظیمات بیشتر استفاده کنید.',
  selectedItems: 'انتخاب\u200cشده\u200cها',
  resultsSelected: 'همهٔ این نتایج انتخاب شده\u200cاند؛ برای حذف از فهرست بالا استفاده کنید.',
  publishSaveFirst: 'ابتدا تغییرات را ذخیره کنید.',
  publishLanguage: 'حداقل یک زبان را فعال کنید.',
  publishFields: 'برچسب پیام، عنوان، متن دکمه و لینک دکمه را کامل کنید.',
  publishConfirmFirst: 'پس از بررسی پیام و شرایط نمایش، تیک تأیید پایین را بزنید.',
  previewSaveFirst: 'برای دیدن پیام داخل مطلب، ابتدا پیش\u200cنویس یا تغییرات را ذخیره کنید.',
  previewChooseFirst: 'یک مطلب را انتخاب کنید. این فهرست ابتدا فقط مطالب انتخاب\u200cشدهٔ کمپین را نشان می\u200cدهد.',

  sessionChanged: 'دسترسی حساب تغییر کرده است. نتیجهٔ درخواست قبلی را در فهرست کمپین‌ها بررسی کنید.',
  reconcileCreation: 'بررسی نتیجهٔ همین درخواست',
  creationRecovered: 'درخواست ثبت شده است. وضعیت فعلی را بررسی کنید و نسخهٔ ذخیره‌شده را باز کنید.',
  requestUnavailable: 'امکان ارسال امن در این مرورگر فراهم نیست. صفحه را در مرورگر به‌روز باز کنید.',
  duplicateCompleted: 'یک نسخهٔ پیش‌نویس از کمپین ساخته شد.',
  publishCompleted: 'کمپین منتشر شد؛ نمایش آن به زمان‌بندی و شرایط نمایش بستگی دارد.',
  resumeCompleted: 'کمپین دوباره فعال شد؛ زمان‌بندی و شرایط نمایش همچنان اعمال می‌شوند.',
  pauseCompleted: 'کمپین متوقف شد و دیگر نمایش داده نمی‌شود.',
  archiveCompleted: 'کمپین بایگانی شد و دیگر نمایش داده نمی‌شود.',
  listFailed: 'فهرست کمپین‌ها دریافت نشد. دوباره تلاش کنید.',
  processing: 'در حال انجام…',
  checkSaved: 'بررسی وضعیت ذخیره‌شده',
  savedState: 'وضعیت فعلی روی سرور',
  useSaved: 'نمایش نسخهٔ ذخیره‌شده',
  discardDraft: 'نسخهٔ ذخیره‌شده جای تغییرات این صفحه را می‌گیرد. ادامه می‌دهید؟',
  savedPaused: 'تغییرات ذخیره شد و کمپین متوقف شد؛ برای نمایش دوباره آن را منتشر کنید.',

  retryList: 'دوباره دریافت کن',
  noMatches: 'کمپینی با این فیلترها پیدا نشد.',
  clearFilters: 'پاک کردن فیلترها',
  statusFilter: 'وضعیت کمپین',
  listRegion: 'فهرست کمپین‌ها',
  backToList: 'فهرست کمپین‌ها',
  unsavedLeave: 'تغییرات ذخیره نشده‌اند. از این صفحه خارج می‌شوید؟',
  writeUnconfirmed: 'نتیجهٔ این کار هنوز مشخص نیست. قبل از انجام دوباره، وضعیت کمپین را در فهرست بررسی کنید.',
  saving: 'در حال ذخیره…',
  editingHint: 'ذخیرهٔ تغییرات به‌تنهایی کمپین را منتشر نمی‌کند.',

  imagePreviewUnavailable: 'تصویر ذخیره شده است؛ پیش‌نمایش فوری فعلاً در دسترس نیست.',
  uploadRejected: 'این تصویر قابل پردازش نیست؛ آن را به‌صورت JPG یا PNG معمولی ذخیره و دوباره انتخاب کنید.',
  uploadTooLarge: 'حجم تصویر بیش از حد مجاز است؛ تصویر کوچک‌تری انتخاب کنید.',
  uploadRateLimited: 'درخواست‌ها زیاد است؛ کمی صبر کنید و دوباره تصویر را انتخاب کنید.',
  uploadSession: 'نشست شما تمام شده است؛ دوباره وارد شوید.',
  uploadUnavailable: 'بارگذاری تصویر فعلاً در دسترس نیست؛ بعداً دوباره تلاش کنید.',

  shareImages: 'استفاده از این تصویر در زبان‌های فعال',
  shareImagesHint: 'تصویر زبان‌های فعال با تصویر فعلی جایگزین می‌شود؛ متن و دکمه‌ها تغییر نمی‌کنند.',
  sharedImages: 'تصویر در زبان‌های فعال یکسان شد؛ متن‌ها حفظ شدند.',

  globalFallback: 'اگر مطلب یا موضوعی انتخاب نشده، در همه مطالب مجاز نمایش بده',
  globalFiltered: 'با انتخاب‌های فعلی، پیام فقط در مطالب مطابق نمایش داده می‌شود.',
  positiveSummary: 'محدود به انتخاب‌های شما',

  selectDevice: 'حداقل یک دستگاه را برای نمایش انتخاب کنید.',
  selectContentType: 'حداقل یک نوع مطلب را انتخاب کنید.',

  copyEmptyLanguages: 'کپی پیام در زبان‌های خالی',
  copyEmptyHint: 'پیام و تصویر فعلی برای زبان‌های فعالِ بدون متن کپی می‌شوند؛ ترجمه‌های موجود تغییر نمی‌کنند.',
  copyDone: 'پیام در زبان‌های خالی کپی شد. ترجمه‌های موجود حفظ شدند.',

  marketingConfirm: 'تأیید می‌کنم این تصویر برای معرفی عمومی خدمات قابل استفاده است.',

  detailsStep: '۱. پیام کمپین',
  audienceStep: '۲. مخاطب و محل نمایش',
  scheduleStep: '۳. زمان نمایش',
  advanced: 'تنظیمات بیشتر',
  advancedActive: 'تنظیمات اضافی این کمپین فعال‌اند',
  livePreview: 'پیش‌نمایش کمپین',
  livePreviewHint: 'این نمونه با تغییرات شما به‌روز می‌شود. برای نمایش واقعی باید کمپین ذخیره و منتشر شود.',
  allLanguages: 'فعال در هر سه زبان',
  languagesHint: 'هر زبان متن و دکمه خودش را دارد. فعال یا غیرفعال کردن زبان‌ها، ترجمه‌ها را تغییر نمی‌دهد.',
  desktopImage: 'تصویر بنر',
  mobileImage: 'تصویر مخصوص موبایل (اختیاری)',
  upload: 'انتخاب تصویر',
  uploading: 'در حال بارگذاری تصویر…',
  uploadFailed: 'تصویر بارگذاری نشد؛ تصویر قبلی حفظ شده است. دوباره تلاش کنید.',
  uploadInvalid: 'یک تصویر PNG یا JPEG تا ۸ مگابایت انتخاب کنید.',
  removeImage: 'حذف تصویر',
  uploadCheckAgain: 'بررسی دوبارهٔ بارگذاری',
  uploadCheckFailed: 'وضعیت بارگذاری تصویر دریافت نشد. اتصال را بررسی کنید و دوباره امتحان کنید.',
  uploadConfirmFirst: 'برای انتخاب تصویر، ابتدا تأیید کنید که استفادهٔ عمومی از آن مجاز است. فایل باید JPG یا PNG باشد.',
  uploadDisabled: 'بارگذاری تصویر هنوز برای این محیط فعال نشده است.',
  uploadHint: 'تصویر فقط برای معرفی خدمات عمومی باشد؛ عکس یا اطلاعات بیماران را بارگذاری نکنید.',
  devices: 'نمایش در دستگاه‌ها',
  desktopScope: 'دسکتاپ و تبلت',
  mobileScope: 'موبایل',
  startTehran: 'شروع، به وقت تهران',
  endTehran: 'پایان، به وقت تهران',
  tehranHint: 'تاریخ را از تقویم شمسی انتخاب کنید و زمان را به وقت تهران وارد کنید. خالی بودن شروع یعنی از زمان انتشار؛ خالی بودن پایان یعنی بدون تاریخ پایان.',
  invalidDate: 'تاریخ و ساعت معتبر وارد کنید؛ این زمان ممکن است به علت تغییر ساعت رسمی وجود نداشته باشد.',
  invalidWindow: 'زمان پایان باید بعد از زمان شروع باشد.',
  incompleteLanguage: 'عنوان، متن دکمه یا لینک این زبان را کامل کنید.',
  missingLabel: 'برچسب بالای پیام را برای این زبان بنویسید.',
  labelHint: 'این متن کوتاه بالای پیام نمایش داده می‌شود و برای انتشار لازم است؛ مثلاً «خدمات مام».',
  chooseAudience: 'انتخاب مطالب مناسب',
  showEverywhere: 'نمایش در همه مطالب مجاز',
  savedPreview: 'بررسی روی یک مطلب',
  savedPreviewHint: 'بررسی دقیق شرط‌ها با نسخه ذخیره‌شده انجام می‌شود. ابتدا تغییرات را ذخیره کنید.',
  activeExtra: 'شرط یا تنظیم اضافی',
  imageUnavailable: 'تصویر این زبان دریافت نشده است.',

  pickerSearch: 'جست‌وجوی نام یا عنوان',
  noOptions: 'موردی پیدا نشد؛ عبارت دیگری را جست‌وجو کنید.',
  lookupFailed: 'نام این انتخاب دریافت نشد؛ برای تلاش دوباره جست‌وجو کنید.',
  optionUnavailable: 'این انتخاب دیگر در دسترس نیست؛ حذفش کنید یا مورد دیگری انتخاب کنید.',
  actionCoverageUnavailable: 'برای بخشی از داده‌های قدیمی، نمایش معتبرِ این دکمه مشخص نیست؛ تعداد نمایش و نرخ کلیک آن قابل محاسبه نیست. شمار کلیک‌های ثبت‌شده همچنان نمایش داده می‌شود.',
  status: 'وضعیت',
  combineRules: 'ترکیب گروه‌های شرط',
  groupMode: 'شرط‌های این گروه',
  tablet: 'تبلت',
  blue: 'آبی ملایم',
  rose: 'صورتی ملایم',
  neutral: 'خنثی',
  cancel: 'انصراف',
  device: 'دستگاه',
  actionId: 'شناسه دکمه',
  trends: 'روند روزانه',
  topContent: 'مطالب با بیشترین کلیک',
  withoutImpression: 'کلیک بدون نمایش معتبر',
  reconcile: 'بازسازی آمار روز',
  reconcileDay: 'روز مورد نظر (UTC)',
  publishedEdit: 'ویرایش پیام منتشرشده نمایش آن را متوقف می‌کند؛ پس از بررسی دوباره ادامه نمایش را بزنید.',
  title: 'کمپین‌های محتوا',
  intro: 'یک پیام مرتبط برای چند مطلب؛ با زمان‌بندی و کنترل کامل نمایش.',
  create: 'کمپین جدید',
  edit: 'ویرایش کمپین',
  save: 'ذخیره پیش‌نویس',
  saved: 'تغییرات ذخیره شد.',
  failed: 'ارتباط برقرار نشد. نوشته‌های شما حفظ شده‌اند؛ دوباره تلاش کنید.',
  forbidden: 'برای این کار دسترسی ندارید.',
  conflict: 'این کمپین در جای دیگری تغییر کرده است. نسخه تازه را باز کنید؛ نوشته‌های فعلی شما هنوز در فرم هستند.',
  reload: 'باز کردن نسخه تازه',
  search: 'جست‌وجوی نام کمپین',
  all: 'همه وضعیت‌ها',
  draft: 'پیش‌نویس',
  published: 'منتشرشده',
  active: 'در حال نمایش',
  scheduled: 'زمان‌بندی‌شده',
  ended: 'پایان‌یافته',
  paused: 'متوقف',
  archived: 'بایگانی‌شده',
  empty: 'هنوز کمپینی وجود ندارد.',
  retry: 'تلاش دوباره',
  noResults: 'کمپینی با این جستجو پیدا نشد. جستجو یا وضعیت را تغییر دهید.',
  name: 'نام کمپین',
  description: 'یادداشت داخلی',
  language: 'زبان پیام',
  enabled: 'نمایش در این زبان',
  label: 'برچسب بالای پیام',
  heading: 'عنوان',
  body: 'متن پیام',
  template: 'قالب',
  image: 'بنر تصویری',
  text: 'کارت متنی',
  compact: 'نوار کوتاه',
  theme: 'رنگ قالب',
  imageId: 'شناسه تصویر عمومی',
  mobileImageId: 'شناسه تصویر موبایل',
  alt: 'توضیح تصویر',
  action: 'دکمه اصلی',
  secondary: 'دکمه دوم (اختیاری)',
  actionLabel: 'متن دکمه',
  internalUrlHint: 'برای لینک داخلی فقط مسیر را وارد کنید؛ مثلاً /service/egg-Bank، بدون https://mom.ir. مسیر باید از بخش‌های مجاز سایت باشد.',
  externalUrlHint: 'لینک بیرونی باید با https:// شروع شود و دامنهٔ آن در سرور تأیید شده باشد؛ بدون نام کاربری، رمز، پورت یا پارامتر جست‌وجو.',
  destination: 'مقصد',
  internal: 'صفحه داخلی',
  external: 'پیوند بیرونی',
  form: 'فرم تأییدشده',
  url: 'نشانی مقصد',
  newTab: 'باز کردن در تب جدید',
  rules: 'مطالب مناسب این پیام',
  ruleIntro: 'شرط‌های مثبت تعیین می‌کنند پیام کجا بیاید. موارد استثنا همیشه مانع نمایش می‌شوند.',
  allGroups: 'همه گروه‌های شرط برقرار باشند',
  anyGroups: 'حداقل یک گروه برقرار باشد',
  contentTypes: 'نوع مطلب',
  'article-category': 'صفحه دسته‌بندی مقاله‌ها',
  article: 'مقاله',
  video: 'ویدیو',
  contentIds: 'مطالب',
  categoryIds: 'دسته‌بندی‌ها',
  tagIds: 'برچسب‌ها',
  keywords: 'عبارت‌های کلیدی',
  exclusion: 'موارد استثنا',
  phrases: 'هر عبارت در یک خط',
  ids: 'شناسه‌های انتخاب‌شده، با ویرگول جدا شوند',
  global: 'نمایش در همه مطالب مجاز را تأیید می‌کنم',
  globalHint: 'بدون شرط مثبت، انتشار فقط با تأیید صریح دامنه سراسری ممکن است.',
  related: 'دسته‌بندی‌های مرتبط هم بررسی شوند',
  keywordScope: 'جست‌وجوی عبارت در',
  titleOnly: 'عنوان',
  bodyOnly: 'متن',
  both: 'عنوان و متن',
  any: 'حداقل یکی',
  every: 'همه موارد',
  doctorUnavailable: 'شرط پزشک برای این مطالب فعال نیست؛ ارتباط عمومیِ تأییدشده‌ای بین پزشک و این مطلب ثبت نشده است.',
  schedule: 'زمان و محل نمایش',
  start: 'شروع (UTC)',
  end: 'پایان (UTC)',
  timezone: 'منطقه زمانی نمایش',
  utcHint: 'زمان‌ها با UTC ذخیره می‌شوند؛ پایان بازه شامل نمایش نمی‌شود.',
  priority: 'اولویت (۰ تا ۱۰۰)',
  position: 'جای نمایش',
  automatic: 'خودکار، در نقطه مناسب متن',
  endPosition: 'پایان مطلب',
  inherit: 'طبق تنظیم کمپین',
  preview: 'پیش‌نمایش و بررسی',
  previewContent: 'مطلب پیش‌نمایش',
  previewHint: 'این پیش‌نمایش هیچ رویداد آماری ثبت نمی‌کند.',
  noPreview: 'این پیام برای مطلب انتخاب‌شده قابل نمایش نیست.',
  publish: 'انتشار',
  pause: 'توقف نمایش',
  resume: 'ادامه نمایش',
  archive: 'بایگانی',
  duplicate: 'ساخت نسخه جدید',
  confirmPublish: 'پیام، مقصد و دامنه نمایش را بررسی کرده‌ام.',
  confirmArchive: 'بایگانی شود؟ تاریخچه و آمار محفوظ می‌مانند.',
  previous: 'صفحه قبل',
  next: 'صفحه بعد',
  page: 'صفحه',
  updated: 'آخرین تغییر',
  reports: 'آمار کمپین‌ها',
  viewStats: 'مشاهده آمار',
  reportAll: 'همه',
  reportDay: 'تاریخ',
  reportTimezone: 'بازهٔ تاریخ و آمار روزانه بر اساس ساعت جهانی (UTC) است.',
  tehranTime: 'ساعت تهران',
  statsDisabled: 'ثبت آمار جدید فعال نیست. اگر آمار قبلی موجود باشد، نمایش داده می‌شود.',
  statsUnavailable: 'آمار فعلاً در دسترس نیست. دوباره تلاش کنید.',
  statsPending: 'آمار این بازه هنوز آماده نشده است. چند دقیقه دیگر دوباره بررسی کنید.',
  statsPartial: 'آمار بعضی روزهای این بازه هنوز آماده نیست؛ اعداد فعلی فقط روزهای آماده‌شده را نشان می‌دهند.',
  statsStale: 'این آمار هنوز به‌روز نشده است؛ اعداد آخرین محاسبه نمایش داده می‌شوند.',
  statsRefresh: 'آمار تقریباً هر پنج دقیقه به‌روز می‌شود.',

  impressions: 'تعداد نمایش',
  clicks: 'کلیک',
  ctr: 'نرخ کلیک',
  revision: 'نسخه پیام',
  reportHint: 'نمایش یعنی دیده‌شدن حداقل نیمی از کمپین برای یک ثانیه. نرخ کلیک، سهم نمایش‌هایی است که به کلیک رسیده‌اند؛ این اعداد تعداد افراد یا نوبت‌ها نیستند.',
  conversion: 'اندازه‌گیری ثبت موفق فرم در دسترس نیست.',
  from: 'از تاریخ',
  to: 'تا تاریخ',
  filter: 'اعمال فیلتر',
  export: 'دریافت CSV',
  refresh: 'آخرین به‌روزرسانی',
  unknown: 'در دسترس نیست',
  settingTitle: 'پیام مرتبط در این مطلب',
  settingIntro: 'این تنظیم فقط برای زبان فعلی مطلب است.',
  selectionMode: 'نحوه انتخاب کمپین',
  automaticSelection: 'انتخاب خودکار کمپین مناسب',
  manual: 'انتخاب یک کمپین',
  disabled: 'بدون نمایش کمپین',
  manualHint: 'انتخاب دستی فقط شرط‌های مثبت را کنار می‌گذارد؛ زمان، زبان و استثناها همچنان بررسی می‌شوند.',
  choose: 'انتخاب کمپین',
  unavailable: 'کمپین انتخاب‌شده دیگر در فهرست نیست؛ پیش از ذخیره بررسی کنید.',
  loading: 'در حال دریافت…',
  manage: 'مدیریت کمپین‌ها',
  pick: 'جست‌وجو و انتخاب',
  remove: 'حذف از انتخاب',
  viewport: 'اندازه پیش‌نمایش',
  desktop: 'دسکتاپ',
  mobile: 'موبایل',
  coverage: 'پوشش داده\u200cهای گزارش',
  coverageUnknown: 'کامل بودن داده\u200cهای این بازه مشخص نیست؛ صفر بودن آمار به معنی نبود فعالیت نیست.',
  coveragecomplete: 'خلاصهٔ روزانه برای همهٔ روزهای انتخاب\u200cشده موجود است.',
  coveragepartial: 'داده\u200cهای بعضی روزها آماده نیست؛ آمار فقط روزهای موجود را پوشش می\u200cدهد.',
  coveragenone: 'برای این بازه هنوز خلاصهٔ روزانه\u200cای موجود نیست؛ آمار صفر را نتیجهٔ قطعی در نظر نگیرید.',
  missingDays: 'روزهای بدون خلاصه (UTC)',
  summaryTotalsHint: 'این آمار فقط رویدادهای ثبت\u200cشده را نشان می\u200cدهد، نه همهٔ بازدیدها یا نوبت\u200cهای موفق.',
  exportIncomplete: 'برای دانلود، کامل بودن خلاصه\u200cهای همهٔ روزهای انتخاب\u200cشده باید تأیید شود.',
  emptyUnknown: 'ردیفی برای نمایش نیست و کامل بودن داده\u200cها مشخص نیست.',
  emptyIncomplete: 'ردیفی در خلاصه\u200cهای موجود پیدا نشد؛ داده\u200cهای روزهای بدون خلاصه هنوز مشخص نیست.',
  noMetrics: 'در خلاصه\u200cهای همهٔ روزهای انتخاب\u200cشده، رویدادی مطابق این فیلترها ثبت نشده است.',
}
const en = {
  ...fa,
  pickerNarrow: 'Search for a more specific name or title to see the remaining results.',
  pickerLimit: 'You can select up to {count} items. Remove one to select another.',
  pickerResults: 'Search results',
  pickerPages: 'Search result pages',
  pickerPage: 'Page {page} of {pages}',
  tagSearchHint: 'Typing does not select a tag. Choose Search and select, then select a result.',
  noTagOptions: 'No tags found. Try a shorter name, or add a keyword phrase to match article text.',
  tagSuggestions: 'No exact match was found. Review these similar names; nothing has been selected.',
  searchOtherArticles: 'Search other articles',
  reviewRequired: 'Review required fields',
  titleBodyTags: 'Title, body and tag names',
  tagMatchingHint: 'Tags match the article’s assigned tags. To find words in text or tag names, use keyword phrases under advanced settings.',
  selectedItems: 'Selected items',
  resultsSelected: 'All these results are selected. Remove items using the list above.',
  publishSaveFirst: 'Save your changes first.',
  publishLanguage: 'Enable at least one language.',
  publishFields: 'Complete the message label, title, button text and button link.',
  publishConfirmFirst: 'Review the message and display rules, then select the confirmation below.',
  previewSaveFirst: 'Save the draft or your changes before viewing the message inside an article.',
  previewChooseFirst: 'Choose an article. This list initially shows only the campaign’s selected articles.',

  sessionChanged: 'Account access changed. Check the previous request in the campaign list.',
  reconcileCreation: 'Check this request',
  creationRecovered: 'The request was saved. Review its current status and open the saved version.',
  requestUnavailable: 'Secure submission is unavailable in this browser. Open this page in an updated browser.',
  duplicateCompleted: 'A draft copy of the campaign was created.',
  publishCompleted: 'Campaign published. Its schedule and display rules still apply.',
  resumeCompleted: 'Campaign resumed. Its schedule and display rules still apply.',
  pauseCompleted: 'Campaign paused. It will no longer be displayed.',
  archiveCompleted: 'Campaign archived. It will no longer be displayed.',
  listFailed: 'The campaign list could not be loaded. Please try again.',
  processing: 'Working…',
  checkSaved: 'Check saved status',
  savedState: 'Current server status',
  useSaved: 'View saved version',
  discardDraft: 'The saved version will replace your changes on this page. Continue?',
  savedPaused: 'Changes saved and the campaign paused. Publish it again to display it.',

  retryList: 'Try again',
  noMatches: 'No campaigns match these filters.',
  clearFilters: 'Clear filters',
  statusFilter: 'Campaign status',
  listRegion: 'Campaign list',
  backToList: 'Campaign list',
  unsavedLeave: 'Your changes have not been saved. Leave this page?',
  writeUnconfirmed: 'The result is not confirmed. Check the campaign list before doing this again.',
  saving: 'Saving…',
  editingHint: 'Saving changes does not publish the campaign.',

  imagePreviewUnavailable: 'The image is saved; immediate preview is currently unavailable.',
  uploadRejected: 'This image could not be processed. Save it as a standard JPG or PNG and choose it again.',
  uploadTooLarge: 'The image exceeds the size limit. Choose a smaller image.',
  uploadRateLimited: 'Too many requests. Wait a little, then choose the image again.',
  uploadSession: 'Your session expired. Please sign in again.',
  uploadUnavailable: 'Image uploads are temporarily unavailable. Please try again later.',
  shareImages: 'Use this image in enabled languages',
  shareImagesHint: 'Replace images in enabled languages with the current image. Text and buttons are preserved.',
  sharedImages: 'Images updated in enabled languages. Text was preserved.',
  globalFallback: 'Display across eligible content when no content or topics are selected',
  globalFiltered: 'With the current conditions, this message only appears in matching content.',
  positiveSummary: 'Limited to your selections',
  selectDevice: 'Choose at least one display device.',
  selectContentType: 'Choose at least one content type.',
  copyEmptyLanguages: 'Copy message to empty languages',
  copyEmptyHint: 'Copy this message and image to enabled languages without content. Existing translations are preserved.',
  copyDone: 'Copied to empty languages. Existing translations were preserved.',
  marketingConfirm: 'I confirm this image may be used to promote public services.',
  detailsStep: '1. Campaign message',
  audienceStep: '2. Audience and placement',
  scheduleStep: '3. Display schedule',
  advanced: 'More settings',
  advancedActive: 'Additional settings are active',
  livePreview: 'Campaign preview',
  livePreviewHint: 'This preview follows your changes. Actual display requires saving and publishing.',
  allLanguages: 'Enable all three languages',
  languagesHint: 'Each language has its own message and button. Toggling languages preserves translations.',
  desktopImage: 'Banner image',
  mobileImage: 'Mobile image (optional)',
  upload: 'Choose image',
  uploading: 'Uploading image…',
  uploadFailed: 'Upload failed. The previous image is preserved; try again.',
  uploadInvalid: 'Choose a PNG or JPEG image up to 8 MB.',
  removeImage: 'Remove image',
  uploadCheckAgain: 'Check upload availability again',
  uploadCheckFailed: 'Image upload availability could not be checked. Check your connection and try again.',
  uploadConfirmFirst: 'To choose an image, first confirm that it may be used publicly. Use a JPG or PNG file.',
  uploadDisabled: 'Image uploads are not enabled for this environment.',
  uploadHint: 'Use approved public service imagery only. Do not upload patient images or information.',
  devices: 'Display on devices',
  desktopScope: 'Desktop and tablet',
  mobileScope: 'Mobile',
  startTehran: 'Start, Tehran time',
  endTehran: 'End, Tehran time',
  tehranHint: 'Enter Tehran time. An empty start means from publication; an empty end means no end date.',
  invalidDate: 'Enter a valid date and time. Clock changes can make a local time unavailable.',
  invalidWindow: 'End must be after start.',
  incompleteLanguage: 'Complete the title, button text or link for this language.',
  missingLabel: 'Add the message label for this language.',
  labelHint: 'This short label appears above the message and is required for publication, for example “MOM services”.',
  chooseAudience: 'Choose relevant content',
  showEverywhere: 'Display across all eligible content',
  savedPreview: 'Check against content',
  savedPreviewHint: 'Eligibility checks use the saved version. Save your changes first.',
  activeExtra: 'Additional condition or setting',
  imageUnavailable: 'This language’s image could not be loaded.',
  pickerSearch: 'Search name or title',
  noOptions: 'No matches. Try another search.',
  lookupFailed: 'The selected name could not be loaded. Search again to retry.',
  optionUnavailable: 'This selection is unavailable. Remove it or choose another item.',
  actionCoverageUnavailable: 'Some older data does not identify impressions for this action. Its impression count and CTR are unavailable; recorded clicks are still shown.',
  status: 'State',
  combineRules: 'Combine condition groups',
  groupMode: 'Conditions in this group',
  tablet: 'Tablet',
  blue: 'Soft blue',
  rose: 'Soft rose',
  neutral: 'Neutral',
  cancel: 'Cancel',
  device: 'Device',
  actionId: 'Action ID',
  trends: 'Daily trend',
  topContent: 'Top content by clicks',
  withoutImpression: 'Clicks without a valid impression',
  reconcile: 'Reconcile one day',
  reconcileDay: 'Day (UTC)',
  publishedEdit: 'Saving a published campaign pauses display. Review it, then resume.',
  title: 'Content campaigns',
  intro: 'A relevant message across your content, with clear scheduling and display controls.',
  create: 'New campaign',
  edit: 'Edit campaign',
  save: 'Save draft',
  saved: 'Changes saved.',
  failed: 'Connection failed. Your draft is preserved; please try again.',
  forbidden: 'You do not have permission for this action.',
  conflict: 'This campaign changed elsewhere. Load the latest version; your current draft is still in the form.',
  reload: 'Load latest version',
  search: 'Search campaign name',
  all: 'All states',
  draft: 'Draft',
  published: 'Published',
  active: 'Active',
  scheduled: 'Scheduled',
  ended: 'Ended',
  paused: 'Paused',
  archived: 'Archived',
  empty: 'No campaigns yet.',
  retry: 'Try again',
  noResults: 'No campaigns match this search. Change the search or status.',
  name: 'Campaign name',
  description: 'Internal note',
  language: 'Message language',
  enabled: 'Enable this language',
  label: 'Message label',
  heading: 'Title',
  body: 'Message',
  template: 'Template',
  image: 'Image banner',
  text: 'Text card',
  compact: 'Compact strip',
  theme: 'Theme',
  imageId: 'Public image ID',
  mobileImageId: 'Mobile image ID',
  alt: 'Image description',
  action: 'Primary action',
  secondary: 'Secondary action (optional)',
  actionLabel: 'Button label',
  internalUrlHint: 'For an internal link, enter an approved site path such as /service/egg-Bank, without https://mom.ir.',
  externalUrlHint: 'Use an HTTPS link to a server-approved domain, without credentials, a port or query parameters.',
  destination: 'Destination',
  internal: 'Internal page',
  external: 'External link',
  form: 'Approved form',
  url: 'Destination URL',
  newTab: 'Open in a new tab',
  rules: 'Where this message belongs',
  ruleIntro: 'Positive conditions select content. Exclusions always prevent display.',
  allGroups: 'Match all condition groups',
  anyGroups: 'Match any condition group',
  contentTypes: 'Content type',
  'article-category': 'Article category page',
  article: 'Article',
  video: 'Video',
  contentIds: 'Content',
  categoryIds: 'Categories',
  tagIds: 'Tags',
  keywords: 'Keyword phrases',
  exclusion: 'Exclusions',
  phrases: 'One phrase per line',
  ids: 'Selected IDs, separated by commas',
  global: 'I confirm display across all eligible content',
  globalHint: 'Publishing without positive conditions requires explicit global scope confirmation.',
  related: 'Include related categories',
  keywordScope: 'Find phrases in',
  titleOnly: 'Title',
  bodyOnly: 'Body',
  both: 'Title and body',
  any: 'Any item',
  every: 'All items',
  doctorUnavailable: 'Doctor conditions are unavailable: no verified public relationship between a doctor and this content is recorded.',
  schedule: 'Schedule and placement',
  start: 'Starts at (UTC)',
  end: 'Ends at (UTC)',
  timezone: 'Display timezone',
  utcHint: 'Times are stored as UTC. Display stops at the end boundary.',
  priority: 'Priority (0–100)',
  position: 'Placement',
  automatic: 'Automatic, at a suitable text boundary',
  endPosition: 'End of content',
  inherit: 'Use campaign placement',
  preview: 'Preview and validation',
  previewContent: 'Preview content',
  previewHint: 'Preview does not send analytics events.',
  noPreview: 'This message cannot be displayed for the selected content.',
  publish: 'Publish',
  pause: 'Pause display',
  resume: 'Resume display',
  archive: 'Archive',
  duplicate: 'Duplicate as draft',
  confirmPublish: 'I have reviewed the message, destination and display scope.',
  confirmArchive: 'Archive this campaign? History and reports are retained.',
  previous: 'Previous page',
  next: 'Next page',
  page: 'Page',
  updated: 'Last updated',
  reports: 'Campaign statistics',
  viewStats: 'View statistics',
  reportAll: 'All',
  reportDay: 'Date',
  reportTimezone: 'Date ranges and daily statistics use UTC.',
  tehranTime: 'Tehran time',
  statsDisabled: 'New statistics are not being collected. Previously recorded statistics remain available.',
  statsUnavailable: 'Statistics are currently unavailable. Please try again.',
  statsPending: 'Statistics for this period are not ready yet. Check again in a few minutes.',
  statsPartial: 'Some days are not ready yet. These totals include only available days.',
  statsStale: 'Statistics are awaiting an update. The last calculated totals are shown.',
  statsRefresh: 'Statistics update approximately every five minutes.',

  impressions: 'Impressions',
  clicks: 'Clicks',
  ctr: 'Click-through rate',
  revision: 'Creative revision',
  reportHint: 'CTR uses clicked instances with a valid impression. Only recorded events are covered; these are not counts of people or confirmed bookings.',
  conversion: 'Confirmed form submission tracking is unavailable.',
  from: 'From',
  to: 'To',
  filter: 'Apply filters',
  export: 'Download CSV',
  refresh: 'Last refreshed',
  unknown: 'Unavailable',
  settingTitle: 'Relevant message in this content',
  settingIntro: 'This setting applies to the current content language only.',
  selectionMode: 'Campaign selection',
  automaticSelection: 'Choose automatically',
  manual: 'Select a campaign',
  disabled: 'Hide campaigns',
  manualHint: 'Manual selection bypasses positive rules only. Time, language and exclusions still apply.',
  choose: 'Choose campaign',
  unavailable: 'The selected campaign is no longer listed; check before saving.',
  loading: 'Loading…',
  manage: 'Manage campaigns',
  pick: 'Search and select',
  remove: 'Remove selection',
  viewport: 'Preview size',
  desktop: 'Desktop',
  mobile: 'Mobile',
  coverage: 'Report data coverage',
  coverageUnknown: 'Completeness is unknown for this range; zero totals do not confirm no activity.',
  coveragecomplete: 'Daily summaries are available for every selected day.',
  coveragepartial: 'Some daily summaries are missing; totals cover available days only.',
  coveragenone: 'No daily summaries are available for this range; zero totals are not a confirmed result.',
  missingDays: 'Days without summaries (UTC)',
  summaryTotalsHint: 'These totals cover recorded events only, not all visits or confirmed bookings.',
  exportIncomplete: 'Download is available once summaries for every selected day are confirmed complete.',
  emptyUnknown: 'There are no rows to display and data completeness is unknown.',
  emptyIncomplete: 'No matching rows were found in available summaries; days without summaries remain unknown.',
  noMetrics: 'Summaries for all selected days contain no events matching these filters.',
}
const ar = {
  ...en,
  pickerNarrow: 'ابحث باسم أو عنوان أدق لرؤية بقية النتائج.',
  pickerLimit: 'يمكنك اختيار {count} عنصرًا كحد أقصى. أزل عنصرًا لاختيار غيره.',
  pickerResults: 'نتائج البحث',
  pickerPages: 'صفحات نتائج البحث',
  pickerPage: 'الصفحة {page} من {pages}',
  tagSearchHint: 'كتابة الاسم لا تختار الوسم. اضغط البحث والاختيار ثم اختر نتيجة.',
  noTagOptions: 'لم نعثر على وسوم. جرّب اسمًا أقصر، أو أضف عبارة مفتاحية للبحث في نص المقال.',
  tagSuggestions: 'لم نعثر على تطابق دقيق. راجع هذه الأسماء المتشابهة؛ لم يتم اختيار أي منها.',
  searchOtherArticles: 'البحث في مقالات أخرى',
  reviewRequired: 'مراجعة الحقول المطلوبة',
  titleBodyTags: 'العنوان والنص وأسماء الوسوم',
  tagMatchingHint: 'تطابق الوسوم الوسوم المسندة إلى المقال. للبحث عن كلمات في النص أو أسماء الوسوم، استخدم العبارات المفتاحية في الإعدادات الإضافية.',
  selectedItems: 'العناصر المختارة',
  resultsSelected: 'تم اختيار كل هذه النتائج. يمكنك إزالتها من القائمة أعلاه.',
  publishSaveFirst: 'احفظ تغييراتك أولًا.',
  publishLanguage: 'فعّل لغة واحدة على الأقل.',
  publishFields: 'أكمل تسمية الرسالة والعنوان ونص الزر ورابطه.',
  publishConfirmFirst: 'راجع الرسالة وشروط العرض ثم حدّد مربع التأكيد أدناه.',
  previewSaveFirst: 'احفظ المسودة أو التغييرات قبل معاينة الرسالة داخل المقال.',
  previewChooseFirst: 'اختر مقالًا. تعرض هذه القائمة أولًا مقالات الحملة المختارة فقط.',

  sessionChanged: 'تغيّر وصول الحساب. تحقق من نتيجة الطلب السابق في قائمة الحملات.',
  reconcileCreation: 'التحقق من نتيجة الطلب',
  creationRecovered: 'حُفظ الطلب. راجع حالته الحالية وافتح النسخة المحفوظة.',
  requestUnavailable: 'الإرسال الآمن غير متاح في هذا المتصفح. افتح الصفحة في متصفح محدّث.',
  duplicateCompleted: 'أُنشئت نسخة مسودة من الحملة.',
  publishCompleted: 'نُشرت الحملة. يظل عرضها خاضعًا للجدول الزمني وشروط العرض.',
  resumeCompleted: 'استؤنف عرض الحملة وفق الجدول الزمني وشروط العرض.',
  pauseCompleted: 'أُوقفت الحملة ولن تُعرض بعد الآن.',
  archiveCompleted: 'أُرشفت الحملة ولن تُعرض بعد الآن.',
  listFailed: 'تعذر تحميل قائمة الحملات. حاول مجددًا.',
  processing: 'جارٍ التنفيذ…',
  checkSaved: 'التحقق من الحالة المحفوظة',
  savedState: 'الحالة الحالية على الخادم',
  useSaved: 'عرض النسخة المحفوظة',
  discardDraft: 'ستحل النسخة المحفوظة محل تغييرات هذه الصفحة. هل تريد المتابعة؟',
  savedPaused: 'حُفظت التغييرات وأُوقفت الحملة. انشرها مجددًا لعرضها.',

  retryList: 'حاول مجددًا',
  noMatches: 'لا توجد حملات تطابق هذه الفلاتر.',
  clearFilters: 'مسح الفلاتر',
  statusFilter: 'حالة الحملة',
  listRegion: 'قائمة الحملات',
  backToList: 'قائمة الحملات',
  unsavedLeave: 'لم تُحفظ التغييرات. هل تريد مغادرة الصفحة؟',
  writeUnconfirmed: 'لم تتأكد نتيجة العملية بعد. تحقق من قائمة الحملات قبل تكرارها.',
  saving: 'جارٍ الحفظ…',
  editingHint: 'حفظ التغييرات لا ينشر الحملة.',

  imagePreviewUnavailable: 'حُفظت الصورة؛ المعاينة الفورية غير متاحة حاليًا.',
  uploadRejected: 'تعذر معالجة الصورة؛ احفظها بصيغة JPG أو PNG عادية واخترها مجددًا.',
  uploadTooLarge: 'حجم الصورة يتجاوز الحد المسموح؛ اختر صورة أصغر.',
  uploadRateLimited: 'الطلبات كثيرة؛ انتظر قليلًا ثم اختر الصورة مجددًا.',
  uploadSession: 'انتهت الجلسة؛ سجل الدخول مجددًا.',
  uploadUnavailable: 'رفع الصور غير متاح مؤقتًا؛ حاول لاحقًا.',
  shareImages: 'استخدام هذه الصورة في اللغات المفعلة',
  shareImagesHint: 'تُستبدل صور اللغات المفعلة بالصورة الحالية دون تغيير النص والأزرار.',
  sharedImages: 'وُحّدت الصور في اللغات المفعلة مع حفظ النصوص.',
  globalFallback: 'العرض في كل المحتوى المؤهل عندما لا يُختار محتوى أو موضوع',
  globalFiltered: 'مع الشروط الحالية تظهر الرسالة في المحتوى المطابق فقط.',
  positiveSummary: 'محدد باختياراتك',
  selectDevice: 'اختر جهازًا واحدًا على الأقل للعرض.',
  selectContentType: 'اختر نوع محتوى واحدًا على الأقل.',
  copyEmptyLanguages: 'نسخ الرسالة إلى اللغات الفارغة',
  copyEmptyHint: 'تُنسخ الرسالة والصورة إلى اللغات المفعلة دون محتوى؛ تبقى الترجمات الموجودة كما هي.',
  copyDone: 'نُسخت الرسالة إلى اللغات الفارغة مع حفظ الترجمات الموجودة.',
  marketingConfirm: 'أؤكد أن هذه الصورة مسموح استخدامها للتعريف بالخدمات العامة.',
  detailsStep: '١. رسالة الحملة',
  audienceStep: '٢. الجمهور ومكان العرض',
  scheduleStep: '٣. موعد العرض',
  advanced: 'إعدادات إضافية',
  advancedActive: 'توجد إعدادات إضافية مفعلة',
  livePreview: 'معاينة الحملة',
  livePreviewHint: 'تتحدث المعاينة مع تغييراتك. العرض الفعلي يتطلب الحفظ والنشر.',
  allLanguages: 'تفعيل اللغات الثلاث',
  languagesHint: 'لكل لغة رسالتها وزرها. تغيير اللغات المفعلة لا يغير الترجمات.',
  desktopImage: 'صورة اللافتة',
  mobileImage: 'صورة الهاتف (اختيارية)',
  upload: 'اختيار صورة',
  uploading: 'جارٍ رفع الصورة…',
  uploadFailed: 'تعذر رفع الصورة؛ احتُفظ بالصورة السابقة. حاول مجددًا.',
  uploadInvalid: 'اختر صورة PNG أو JPEG بحجم أقصى ٨ ميغابايت.',
  removeImage: 'إزالة الصورة',
  uploadCheckAgain: 'التحقق من الرفع مجددًا',
  uploadCheckFailed: 'تعذر التحقق من توفر رفع الصور. تحقق من الاتصال وحاول مجددًا.',
  uploadConfirmFirst: 'لاختيار صورة، أكد أولًا أن استخدامها العام مسموح. استخدم ملف JPG أو PNG.',
  uploadDisabled: 'رفع الصور غير مفعل لهذه البيئة.',
  uploadHint: 'استخدم صور الخدمات العامة المعتمدة فقط، دون صور المرضى أو معلوماتهم.',
  devices: 'العرض على الأجهزة',
  desktopScope: 'الحاسوب والجهاز اللوحي',
  mobileScope: 'الهاتف',
  startTehran: 'البداية بتوقيت طهران',
  endTehran: 'النهاية بتوقيت طهران',
  tehranHint: 'أدخل الوقت بتوقيت طهران. البداية الفارغة تعني من النشر والنهاية الفارغة تعني دون نهاية محددة.',
  invalidDate: 'أدخل تاريخًا ووقتًا صالحين؛ قد لا يتوفر وقت محلي عند تغيير الساعة.',
  invalidWindow: 'يجب أن تكون النهاية بعد البداية.',
  incompleteLanguage: 'أكمل العنوان أو نص الزر أو الرابط لهذه اللغة.',
  missingLabel: 'اكتب النص الذي يظهر أعلى الرسالة لهذه اللغة.',
  labelHint: 'يظهر هذا النص القصير أعلى الرسالة وهو مطلوب للنشر، مثل «خدمات مام».',
  chooseAudience: 'اختيار المحتوى المناسب',
  showEverywhere: 'العرض في كل المحتوى المؤهل',
  savedPreview: 'التحقق على محتوى',
  savedPreviewHint: 'يستخدم التحقق النسخة المحفوظة. احفظ تغييراتك أولًا.',
  activeExtra: 'شرط أو إعداد إضافي',
  imageUnavailable: 'تعذر تحميل صورة هذه اللغة.',
  pickerSearch: 'البحث بالاسم أو العنوان',
  noOptions: 'لم تُوجد نتائج؛ جرّب عبارة أخرى.',
  lookupFailed: 'تعذر تحميل اسم الاختيار؛ ابحث مجددًا للمحاولة.',
  optionUnavailable: 'هذا الاختيار غير متاح؛ أزله أو اختر عنصرًا آخر.',
  actionCoverageUnavailable: 'بعض البيانات القديمة لا تحدد مرات الظهور لهذا الإجراء؛ عدد الظهور ونسبة النقر غير متاحين. تبقى النقرات المسجلة معروضة.',
  status: 'الحالة',
  combineRules: 'دمج مجموعات الشروط',
  groupMode: 'شروط هذه المجموعة',
  tablet: 'جهاز لوحي',
  blue: 'أزرق هادئ',
  rose: 'وردي هادئ',
  neutral: 'محايد',
  cancel: 'إلغاء',
  device: 'الجهاز',
  actionId: 'معرّف الإجراء',
  trends: 'الاتجاه اليومي',
  topContent: 'المحتوى الأعلى نقرًا',
  withoutImpression: 'نقرات دون ظهور معتبر',
  reconcile: 'إعادة بناء إحصاءات يوم',
  reconcileDay: 'اليوم (UTC)',
  publishedEdit: 'حفظ الحملة المنشورة يوقف عرضها؛ راجعها ثم استأنف العرض.',
  title: 'حملات المحتوى',
  intro: 'رسالة مناسبة ضمن المحتوى، مع تحكم واضح في موعد العرض ومكانه.',
  create: 'حملة جديدة',
  edit: 'تعديل الحملة',
  save: 'حفظ المسودة',
  saved: 'تم حفظ التغييرات.',
  failed: 'تعذر الاتصال. تم الاحتفاظ بالمسودة؛ حاول مجددًا.',
  forbidden: 'لا تملك صلاحية لهذا الإجراء.',
  conflict: 'عُدّلت الحملة في مكان آخر. افتح النسخة الأخيرة؛ تبقى مسودتك في النموذج.',
  reload: 'فتح النسخة الأخيرة',
  search: 'البحث باسم الحملة',
  all: 'كل الحالات',
  draft: 'مسودة',
  published: 'منشورة',
  active: 'قيد العرض',
  scheduled: 'مجدولة',
  ended: 'منتهية',
  paused: 'متوقفة',
  archived: 'مؤرشفة',
  empty: 'لا توجد حملات بعد.',
  retry: 'حاول مرة أخرى',
  noResults: 'لا توجد حملات مطابقة لهذا البحث. غيّر البحث أو الحالة.',
  name: 'اسم الحملة',
  description: 'ملاحظة داخلية',
  language: 'لغة الرسالة',
  enabled: 'تفعيل هذه اللغة',
  label: 'النص أعلى الرسالة',
  heading: 'العنوان',
  body: 'نص الرسالة',
  template: 'القالب',
  image: 'لافتة بصورة',
  text: 'بطاقة نصية',
  compact: 'شريط مختصر',
  theme: 'لون القالب',
  imageId: 'معرّف الصورة العامة',
  mobileImageId: 'معرّف صورة الهاتف',
  alt: 'وصف الصورة',
  action: 'الإجراء الرئيسي',
  secondary: 'الإجراء الثاني (اختياري)',
  actionLabel: 'نص الزر',
  internalUrlHint: 'للرابط الداخلي، أدخل مسارًا مسموحًا مثل /service/egg-Bank دون https://mom.ir.',
  externalUrlHint: 'استخدم رابط HTTPS إلى نطاق معتمد في الخادم، دون بيانات دخول أو منفذ أو معاملات بحث.',
  destination: 'الوجهة',
  internal: 'صفحة داخلية',
  external: 'رابط خارجي',
  form: 'نموذج معتمد',
  url: 'عنوان الوجهة',
  newTab: 'فتح في علامة تبويب جديدة',
  rules: 'المحتوى المناسب للرسالة',
  ruleIntro: 'تحدد الشروط الإيجابية المحتوى، وتمنع الاستثناءات العرض دائمًا.',
  allGroups: 'تحقق كل مجموعات الشروط',
  anyGroups: 'تحقق مجموعة واحدة على الأقل',
  contentTypes: 'نوع المحتوى',
  'article-category': 'صفحة تصنيف المقالات',
  article: 'مقال',
  video: 'فيديو',
  contentIds: 'المحتوى',
  categoryIds: 'التصنيفات',
  tagIds: 'الوسوم',
  keywords: 'العبارات المفتاحية',
  exclusion: 'الاستثناءات',
  phrases: 'عبارة واحدة في كل سطر',
  ids: 'المعرّفات المختارة مفصولة بفواصل',
  global: 'أؤكد العرض في كل المحتوى المؤهل',
  globalHint: 'النشر دون شروط إيجابية يتطلب تأكيد النطاق العام.',
  related: 'تضمين التصنيفات المرتبطة',
  keywordScope: 'البحث عن العبارات في',
  titleOnly: 'العنوان',
  bodyOnly: 'النص',
  both: 'العنوان والنص',
  any: 'أي عنصر',
  every: 'كل العناصر',
  doctorUnavailable: 'شروط الأطباء غير متاحة؛ لا توجد علاقة عامة موثقة بين الطبيب وهذا المحتوى.',
  schedule: 'الوقت ومكان العرض',
  start: 'البداية (UTC)',
  end: 'النهاية (UTC)',
  timezone: 'المنطقة الزمنية للعرض',
  utcHint: 'تُحفظ الأوقات بتوقيت UTC؛ يتوقف العرض عند نهاية الفترة.',
  priority: 'الأولوية (٠–١٠٠)',
  position: 'مكان العرض',
  automatic: 'تلقائي عند موضع مناسب في النص',
  endPosition: 'نهاية المحتوى',
  inherit: 'حسب إعداد الحملة',
  preview: 'المعاينة والتحقق',
  previewContent: 'محتوى المعاينة',
  previewHint: 'لا تسجّل المعاينة أحداثًا إحصائية.',
  noPreview: 'لا يمكن عرض الرسالة في المحتوى المختار.',
  publish: 'نشر',
  pause: 'إيقاف العرض',
  resume: 'استئناف العرض',
  archive: 'أرشفة',
  duplicate: 'نسخة جديدة كمسودة',
  confirmPublish: 'راجعت الرسالة والوجهة ونطاق العرض.',
  confirmArchive: 'أرشفة الحملة؟ يُحتفظ بالسجل والتقارير.',
  previous: 'الصفحة السابقة',
  next: 'الصفحة التالية',
  page: 'الصفحة',
  updated: 'آخر تعديل',
  reports: 'إحصاءات الحملات',
  viewStats: 'عرض الإحصاءات',
  reportAll: 'الكل',
  reportDay: 'التاريخ',
  reportTimezone: 'تعتمد الفترة والإحصاءات اليومية على التوقيت العالمي (UTC).',
  tehranTime: 'توقيت طهران',
  statsDisabled: 'تسجيل الإحصاءات الجديدة غير مفعّل. تظهر الإحصاءات السابقة إذا كانت متاحة.',
  statsUnavailable: 'الإحصاءات غير متاحة حاليًا. حاول مرة أخرى.',
  statsPending: 'إحصاءات هذه الفترة ليست جاهزة بعد. تحقق مرة أخرى بعد بضع دقائق.',
  statsPartial: 'إحصاءات بعض الأيام ليست جاهزة بعد. تشمل الأرقام الأيام المتاحة فقط.',
  statsStale: 'الإحصاءات بانتظار التحديث. تظهر آخر أرقام محسوبة.',
  statsRefresh: 'تُحدَّث الإحصاءات كل خمس دقائق تقريبًا.',

  impressions: 'مرات الظهور',
  clicks: 'نقرات',
  ctr: 'نسبة النقر',
  revision: 'نسخة الرسالة',
  reportHint: 'تُحسب النسبة من النقرات ذات الظهور المعتبر. تشمل الإحصاءات الأحداث المسجلة فقط؛ ليست عدد الأشخاص أو الحجوزات.',
  conversion: 'قياس إرسال النموذج المؤكد غير متاح.',
  from: 'من',
  to: 'إلى',
  filter: 'تطبيق المرشحات',
  export: 'تنزيل CSV',
  refresh: 'آخر تحديث',
  unknown: 'غير متاح',
  settingTitle: 'رسالة مناسبة لهذا المحتوى',
  settingIntro: 'هذا الإعداد خاص بلغة المحتوى الحالية.',
  selectionMode: 'طريقة اختيار الحملة',
  automaticSelection: 'اختيار تلقائي',
  manual: 'اختيار حملة',
  disabled: 'إخفاء الحملات',
  manualHint: 'يتجاوز الاختيار اليدوي الشروط الإيجابية فقط؛ يبقى الوقت واللغة والاستثناءات مطبّقة.',
  choose: 'اختيار حملة',
  unavailable: 'الحملة المختارة لم تعد في القائمة؛ تحقق قبل الحفظ.',
  loading: 'جارٍ التحميل…',
  manage: 'إدارة الحملات',
  pick: 'بحث واختيار',
  remove: 'إزالة الاختيار',
  viewport: 'حجم المعاينة',
  desktop: 'حاسوب',
  mobile: 'هاتف',
  coverage: 'تغطية بيانات التقرير',
  coverageUnknown: 'اكتمال البيانات في هذه الفترة غير معروف؛ الأرقام الصفرية لا تؤكد عدم وجود نشاط.',
  coveragecomplete: 'الملخصات اليومية متاحة لكل الأيام المحددة.',
  coveragepartial: 'بعض الملخصات اليومية غير متاحة؛ تشمل الأرقام الأيام المتاحة فقط.',
  coveragenone: 'لا توجد ملخصات يومية لهذه الفترة بعد؛ الأرقام الصفرية ليست نتيجة مؤكدة.',
  missingDays: 'أيام بلا ملخصات (UTC)',
  summaryTotalsHint: 'تشمل الأرقام الأحداث المسجلة فقط، وليس كل الزيارات أو الحجوزات المؤكدة.',
  exportIncomplete: 'يتاح التنزيل بعد التأكد من اكتمال ملخصات جميع الأيام المحددة.',
  emptyUnknown: 'لا توجد صفوف للعرض واكتمال البيانات غير معروف.',
  emptyIncomplete: 'لا توجد صفوف مطابقة في الملخصات المتاحة؛ بيانات الأيام بلا ملخصات غير معروفة بعد.',
  noMetrics: 'لا تحتوي ملخصات جميع الأيام المحددة على أحداث تطابق هذه الفلاتر.',
}
export default { fa, en, ar }
